var _path, _path2, _g, _circle, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 39,
    r: 3,
    fill: "#BC1EF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 46L42 59H57L49.5 46Z",
    fill: "#DF93F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 39L27 59H50L38.5 39Z",
    fill: "#BC1EF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#BC1EF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7706 82.5V72.3182H13.0163C13.7786 72.3182 14.4167 72.4259 14.9304 72.6413C15.4474 72.8568 15.8352 73.1584 16.0938 73.5462C16.3556 73.9339 16.4865 74.383 16.4865 74.8935C16.4865 75.2812 16.4053 75.6276 16.2429 75.9325C16.0805 76.2341 15.8568 76.4844 15.5717 76.6832C15.2867 76.8821 14.9569 77.0213 14.5824 77.1009V77.2003C14.9934 77.2202 15.3729 77.3312 15.7209 77.5334C16.0722 77.7356 16.3539 78.0173 16.5661 78.3786C16.7782 78.7365 16.8842 79.1607 16.8842 79.6513C16.8842 80.1982 16.745 80.687 16.4666 81.1179C16.1882 81.5455 15.7855 81.8835 15.2585 82.1321C14.7315 82.3774 14.0919 82.5 13.3395 82.5H8.7706ZM11.2315 80.5163H12.7528C13.2865 80.5163 13.6792 80.4152 13.9311 80.2131C14.1863 80.0109 14.3139 79.7292 14.3139 79.3679C14.3139 79.1061 14.2526 78.8807 14.13 78.6918C14.0073 78.4995 13.8333 78.352 13.608 78.2493C13.3826 78.1432 13.1125 78.0902 12.7976 78.0902H11.2315V80.5163ZM11.2315 76.5043H12.5938C12.8622 76.5043 13.1009 76.4595 13.3097 76.37C13.5185 76.2805 13.6809 76.1513 13.7969 75.9822C13.9162 75.8132 13.9759 75.6094 13.9759 75.3707C13.9759 75.0294 13.8549 74.7609 13.6129 74.5653C13.371 74.3698 13.0445 74.272 12.6335 74.272H11.2315V76.5043ZM18.0675 72.3182H21.1151L23.7003 78.6222H23.8196L26.4048 72.3182H29.4524V82.5H27.0561V76.2457H26.9716L24.5256 82.4354H22.9943L20.5483 76.2109H20.4638V82.5H18.0675V72.3182ZM30.9874 82.5V72.3182H35.1934C35.9557 72.3182 36.6136 72.4673 37.1671 72.7656C37.7239 73.0606 38.1531 73.4732 38.4547 74.0036C38.7563 74.5305 38.9071 75.1437 38.9071 75.843C38.9071 76.5457 38.753 77.1605 38.4448 77.6875C38.1399 78.2112 37.704 78.6172 37.1373 78.9055C36.5705 79.1939 35.8977 79.3381 35.1188 79.3381H32.5236V77.3991H34.6614C35.0326 77.3991 35.3425 77.3345 35.5911 77.2053C35.843 77.076 36.0336 76.8954 36.1628 76.6634C36.2921 76.428 36.3567 76.1546 36.3567 75.843C36.3567 75.5282 36.2921 75.2564 36.1628 75.0277C36.0336 74.7957 35.843 74.6167 35.5911 74.4908C35.3392 74.3648 35.0293 74.3018 34.6614 74.3018H33.4483V82.5H30.9874Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBmp);
export default __webpack_public_path__ + "static/media/ico_bmp.6ba0c3b43ab1d18361f77c20f1f98c28.svg";
export { ForwardRef as ReactComponent };